import { render, staticRenderFns } from "./safetyHealthyTargetTeamDetail.vue?vue&type=template&id=2d68ecb2"
import script from "./safetyHealthyTargetTeamDetail.vue?vue&type=script&lang=js"
export * from "./safetyHealthyTargetTeamDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d68ecb2')) {
      api.createRecord('2d68ecb2', component.options)
    } else {
      api.reload('2d68ecb2', component.options)
    }
    module.hot.accept("./safetyHealthyTargetTeamDetail.vue?vue&type=template&id=2d68ecb2", function () {
      api.rerender('2d68ecb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/sht/safetyHealthyTargetTeamDetail.vue"
export default component.exports